/**
 * Formatea un importe usando un `currencyId`. Los endpoints suelen exponer sólo
 * el id, así que resolvemos el nombre vía un mapa id→nombre (catálogo de monedas
 * o la propia moneda de la entidad).
 *
 * Formato: número + el NOMBRE de la moneda detrás (p. ej. "25,00 USD"). No se usa
 * el símbolo de moneda ($/US$) por ser redundante con el código.
 *
 * Compartido por `credits` y `billing`.
 */
export function formatAmount(
  amount: number,
  currencyId: number | null | undefined,
  currencyNameById: Map<number, string>,
): string {
  const name = currencyId != null ? currencyNameById.get(currencyId) : undefined

  const formatted = new Intl.NumberFormat('es-CU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount)

  return name ? `${formatted} ${name}` : formatted
}
